var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenFreeMeals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 143,
    viewBox: "0 0 247 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218 97L237.5 101",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 122C62.9086 122 45 104.091 45 82C45 59.9086 62.9086 42 85 42C107.091 42 125 59.9086 125 82C125 104.091 107.091 122 85 122Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 143C86.6995 143 67 123.301 67 99C67 74.6995 86.6995 55 111 55C135.301 55 155 74.6995 155 99C155 123.301 135.301 143 111 143Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133 73C113.118 73 97 56.8823 97 37C97 17.1177 113.118 1 133 1C152.882 1 169 17.1177 169 37C169 56.8823 152.882 73 133 73Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157 111C130.49 111 109 89.5097 109 63C109 36.4903 130.49 15 157 15C183.51 15 205 36.4903 205 63C205 89.5097 183.51 111 157 111Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146 138C119.49 138 98 116.51 98 90C98 63.4903 119.49 42 146 42C172.51 42 194 63.4903 194 90C194 116.51 172.51 138 146 138Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93C66.6995 93 47 73.3005 47 49C47 24.6995 66.6995 5 91 5C115.301 5 135 24.6995 135 49C135 73.3005 115.301 93 91 93Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 8 65)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 49 138)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 247 63)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 42 11)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 200 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 217 138)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.77,
    y: 68.2295,
    width: 18.4615,
    height: 48.4615,
    fill: "#2D2F5F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.2305,
    y: 31.3066,
    width: 101.538,
    height: 73.8462,
    rx: 6.34615,
    fill: "#2D2F5F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 106.538,
    y: 109.769,
    width: 36.9231,
    height: 6.92308,
    rx: 3.46154,
    fill: "#2D2F5F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7695 42.8447L164.231 84.3832",
    stroke: "white",
    strokeWidth: 6.34615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7695 84.3838L164.231 42.8453",
    stroke: "white",
    strokeWidth: 6.34615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M217 28.5L235 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19L19 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5 118L23.5 112.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenFreeMeals);
export default __webpack_public_path__ + "static/media/screen-free-meals.3fd4dfb196ecf4f66ad1c286074ca346.svg";
export { ForwardRef as ReactComponent };